import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ToolsList } from '../../component/tools/ToolsList';
import useSearchParams from '../../hooks/useSearchParams';
import useTablePagination from '../../hooks/useTablePagination';
import { getProductToolsById, listProductTools } from '../../redux/slices/tools/toolsSlice';
import { useDispatch } from '../../redux/store';

export const Available: React.FC<{ siteId?: string }> = ({ siteId }: { siteId?: string }) => {
  const dispatch = useDispatch();
  const [params] = useSearchParams();
  const paramsToUse = useMemo(
    () =>
      Object.keys(params).reduce((partParams, key) => ({ ...partParams, [key]: params[key] }), {
        trackingSiteId: siteId || '',
      }),
    [params, siteId],
  );
  const productTools = useSelector(getProductToolsById(paramsToUse));

  const [pagination, paginationToGet, paginationControl] = useTablePagination({ paginationDirty: productTools.pagination });

  useEffect(() => {
    dispatch(
      listProductTools({
        ...paramsToUse,
        ...paginationToGet,
      }),
    );
  }, [dispatch, paramsToUse, paginationToGet]);

  return (
    <ToolsList items={productTools} paginationControl={paginationControl} pagination={pagination} withAssignedTo withActive withProduct withManufacturer />
  );
};
